import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import DialRedirect from './dashboard/dial/DialRedirect.vue';
import ComposeRedirect from './dashboard/compose/ComposeRedirect.vue';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';
import { phoneLog } from 'dashboard/store/modules/phone';
import {
  clearBrowserSessionCookies,
  clearLocalStorageOnLogout,
} from 'dashboard/store/utils/api';
import { getLoginURLWithReturnTo } from '../helper/loginRedirectHelper';

const routes = [
  ...dashboard.routes,
  {
    path: frontendURL('dial'),
    name: 'dial_redirect',
    component: DialRedirect,
    props: route => ({ number: route.query.number }),
    meta: { skipAuth: true, permissions: [] },
  },
  {
    path: frontendURL('compose'),
    name: 'compose_redirect',
    component: ComposeRedirect,
    props: route => ({ email: route.query.email }),
    meta: { skipAuth: true, permissions: [] },
  },
];

export const router = createRouter({ history: createWebHistory(), routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    // Remember where they were headed: report e-mails link straight into the
    // dashboard, so the reader is very often logged out when they click.
    window.location.assign(getLoginURLWithReturnTo());
    return '';
  }

  if (!user.accounts || user.accounts.length === 0) {
    clearBrowserSessionCookies();
    clearLocalStorageOnLogout();
    window.location.assign('/app/login');
    return '';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  if (nextRoute) phoneLog('validateAuthenticateRoutePermission', { nextRoute });
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  window.addEventListener('popstate', event => {
    phoneLog('popstate event', {
      location: window.location.href,
      state: event.state,
    });
  });

  // eslint-disable-next-line consistent-return
  router.beforeEach((to, _from, next) => {
    phoneLog('route change', { path: to.path, name: to.name });
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    if (to.meta?.skipAuth) {
      return next();
    }

    userAuthentication
      .then(() => {
        return validateAuthenticateRoutePermission(to, next, store);
      })
      .catch(() => {
        // setUser rejected because validate_token kept failing (backend
        // outage). Don't navigate — App.vue renders the "connection lost"
        // screen (hasConnectionError flag) instead of redirecting to /login.
      });
  });
};

export default router;
